module.exports = "<monitoring-dashboard [entityIdDetails]=\"entityIdDetails\">Loading...</monitoring-dashboard>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/monitoring/entitymonitoringorg/entity-monitoring-org.component.html
// module id = 2249
// module chunks = 0